const getKeyFromObject = (obj = {}, key = '') => ((key in obj) ? obj[key] : '');

export default getKeyFromObject;
